"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .controller(
    "passwordResetCtrl",
    function (
      $scope,
      $rootScope,
      $state,
      $stateParams,
      $http,
      $filter,
      $localStorage,
      Auth,
      MessageService,
      settings,
      apiSettings
    ) {
      var vm = this;

      var $translate = $filter("translate");

      $rootScope.laddaLoading = false;

      vm.projectModule = config.projectModule;

      switch (vm.projectModule) {
        case 'SWFlow':
          $(".auth-img").prepend(
            '<img src="/images/logo-sherwin-williams-swflow.png" alt="SWFLOW" />'
          );
          $(".powered-img").prepend(
            '<img src="/Images/img-powered.svg" alt="Powered by Astéria" />'
          );
          break;
        case 'Colors':
          $("body").addClass("a-sua-cor");
          $(".auth-img").prepend(
            '<img src="/images/logo-sw-colorsnap.png" alt="A Sua Cor" />'
          );
          $(".powered-img").prepend(
            '<img src="/Images/img-asuacor-powered.svg" alt="Powered by Astéria" />'
          );
          break;
      }

      if (!$stateParams.email || !$stateParams.token) {
        $state.go("login");
      }

      Auth.validateToken({
        email: $stateParams.email,
        token: $stateParams.token,
      }).$promise.then(null, function (response) {
        MessageService.alertError(response.data);

        $state.go("login");
      });

      vm.model = {
        email: $stateParams.email,
        token: $stateParams.token,
      };

      vm.changePassword = function () {
        if (vm.model.password != vm.model.passwordConfirm) {
          MessageService.alertInfo("Senhas não conferem!");
          return;
        }

        $rootScope.laddaLoading = true;

        Auth.passwordReset(
          {
            email: vm.model.email,
            newPassword: vm.model.password,
            passwordConfirmation: vm.model.passwordConfirm,
            token: vm.model.token,
          },
          function (response) {
            MessageService.alertInfo(
              "Senha alterada com sucesso!",
              "Redefinir senha"
            );

            $state.go("login");
          },
          function (response) {
            vm.auth_error = response.data;

            $rootScope.laddaLoading = false;
          }
        );
      };
    }
  );
